import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=8a4b9906"
import script from "./pay.vue?vue&type=script&lang=js"
export * from "./pay.vue?vue&type=script&lang=js"
import style0 from "./pay.vue?vue&type=style&index=0&id=8a4b9906&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports